'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { useComposerContext } from "./internals/ComposerContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const ComposerAttachmentList = /*#__PURE__*/React.forwardRef(function ComposerAttachmentList(props, ref) {
  const {
      slots,
      slotProps
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const composer = useComposerContext();
  const ownerState = {
    isSubmitting: composer.isSubmitting,
    hasValue: composer.hasValue,
    isStreaming: composer.isStreaming,
    attachmentCount: composer.attachmentCount,
    disabled: composer.disabled
  };
  const AttachmentList = slots?.attachmentList ?? 'div';
  const rootProps = useSlotProps({
    elementType: AttachmentList,
    externalSlotProps: slotProps?.attachmentList,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref
    }
  });
  if (composer.attachments.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(AttachmentList, _extends({}, rootProps));
});
if (process.env.NODE_ENV !== "production") ComposerAttachmentList.displayName = "ComposerAttachmentList";